export default __webpack_public_path__ + "static/media/synteny.c256bc7d.png";